
export interface CountryCode {
    code: string;
    label: string;
    phoneLength: number;
}

export const countryCodes: CountryCode[] = [
    { code: '+1', label: 'United States (+1)', phoneLength: 10 },
    { code: '+1', label: 'Canada (+1)', phoneLength: 10 },
    { code: '+7', label: 'Russia (+7)', phoneLength: 10 },
    { code: '+20', label: 'Egypt (+20)', phoneLength: 10 },
    { code: '+27', label: 'South Africa (+27)', phoneLength: 9 },
    { code: '+30', label: 'Greece (+30)', phoneLength: 10 },
    { code: '+31', label: 'Netherlands (+31)', phoneLength: 9 },
    { code: '+32', label: 'Belgium (+32)', phoneLength: 9 },
    { code: '+33', label: 'France (+33)', phoneLength: 9 },
    { code: '+34', label: 'Spain (+34)', phoneLength: 9 },
    { code: '+36', label: 'Hungary (+36)', phoneLength: 9 },
    { code: '+39', label: 'Italy (+39)', phoneLength: 10 },
    { code: '+40', label: 'Romania (+40)', phoneLength: 9 },
    { code: '+41', label: 'Switzerland (+41)', phoneLength: 9 },
    { code: '+43', label: 'Austria (+43)', phoneLength: 10 },
    { code: '+44', label: 'United Kingdom (+44)', phoneLength: 10 },
    { code: '+45', label: 'Denmark (+45)', phoneLength: 8 },
    { code: '+46', label: 'Sweden (+46)', phoneLength: 9 },
    { code: '+47', label: 'Norway (+47)', phoneLength: 8 },
    { code: '+48', label: 'Poland (+48)', phoneLength: 9 },
    { code: '+49', label: 'Germany (+49)', phoneLength: 10 },
    { code: '+51', label: 'Peru (+51)', phoneLength: 9 },
    { code: '+52', label: 'Mexico (+52)', phoneLength: 10 },
    { code: '+53', label: 'Cuba (+53)', phoneLength: 8 },
    { code: '+54', label: 'Argentina (+54)', phoneLength: 10 },
    { code: '+55', label: 'Brazil (+55)', phoneLength: 11 },
    { code: '+56', label: 'Chile (+56)', phoneLength: 9 },
    { code: '+57', label: 'Colombia (+57)', phoneLength: 10 },
    { code: '+58', label: 'Venezuela (+58)', phoneLength: 10 },
    { code: '+60', label: 'Malaysia (+60)', phoneLength: 9 },
    { code: '+61', label: 'Australia (+61)', phoneLength: 9 },
    { code: '+62', label: 'Indonesia (+62)', phoneLength: 10 },
    { code: '+63', label: 'Philippines (+63)', phoneLength: 10 },
    { code: '+64', label: 'New Zealand (+64)', phoneLength: 9 },
    { code: '+65', label: 'Singapore (+65)', phoneLength: 8 },
    { code: '+66', label: 'Thailand (+66)', phoneLength: 9 },
    { code: '+81', label: 'Japan (+81)', phoneLength: 10 },
    { code: '+82', label: 'South Korea (+82)', phoneLength: 10 },
    { code: '+84', label: 'Vietnam (+84)', phoneLength: 10 },
    { code: '+86', label: 'China (+86)', phoneLength: 11 },
    { code: '+90', label: 'Turkey (+90)', phoneLength: 10 },
    { code: '+91', label: 'India (+91)', phoneLength: 10 },
    { code: '+92', label: 'Pakistan (+92)', phoneLength: 10 },
    { code: '+93', label: 'Afghanistan (+93)', phoneLength: 9 },
    { code: '+94', label: 'Sri Lanka (+94)', phoneLength: 9 },
    { code: '+95', label: 'Myanmar (+95)', phoneLength: 9 },
    { code: '+98', label: 'Iran (+98)', phoneLength: 10 },
    { code: '+211', label: 'South Sudan (+211)', phoneLength: 9 },
    { code: '+212', label: 'Morocco (+212)', phoneLength: 9 },
    { code: '+213', label: 'Algeria (+213)', phoneLength: 9 },
    { code: '+216', label: 'Tunisia (+216)', phoneLength: 8 },
    { code: '+218', label: 'Libya (+218)', phoneLength: 9 },
    { code: '+220', label: 'Gambia (+220)', phoneLength: 7 },
    { code: '+221', label: 'Senegal (+221)', phoneLength: 9 },
    { code: '+222', label: 'Mauritania (+222)', phoneLength: 8 },
    { code: '+223', label: 'Mali (+223)', phoneLength: 8 },
    { code: '+224', label: 'Guinea (+224)', phoneLength: 9 },
    { code: '+225', label: 'Ivory Coast (+225)', phoneLength: 8 },
    { code: '+226', label: 'Burkina Faso (+226)', phoneLength: 8 },
    { code: '+227', label: 'Niger (+227)', phoneLength: 8 },
    { code: '+228', label: 'Togo (+228)', phoneLength: 8 },
    { code: '+229', label: 'Benin (+229)', phoneLength: 8 },
    { code: '+230', label: 'Mauritius (+230)', phoneLength: 8 },
    { code: '+231', label: 'Liberia (+231)', phoneLength: 7 },
    { code: '+232', label: 'Sierra Leone (+232)', phoneLength: 8 },
    { code: '+233', label: 'Ghana (+233)', phoneLength: 9 },
    { code: '+234', label: 'Nigeria (+234)', phoneLength: 10 },
    { code: '+235', label: 'Chad (+235)', phoneLength: 8 },
    { code: '+236', label: 'Central African Republic (+236)', phoneLength: 8 },
    { code: '+237', label: 'Cameroon (+237)', phoneLength: 9 },
    { code: '+238', label: 'Cape Verde (+238)', phoneLength: 7 },
    { code: '+239', label: 'São Tomé and Príncipe (+239)', phoneLength: 7 },
    { code: '+240', label: 'Equatorial Guinea (+240)', phoneLength: 9 },
    { code: '+241', label: 'Gabon (+241)', phoneLength: 7 },
    { code: '+242', label: 'Congo (+242)', phoneLength: 9 },
    { code: '+243', label: 'DR Congo (+243)', phoneLength: 9 },
    { code: '+244', label: 'Angola (+244)', phoneLength: 9 },
    { code: '+245', label: 'Guinea-Bissau (+245)', phoneLength: 7 },
    { code: '+246', label: 'Diego Garcia (+246)', phoneLength: 7 },
    { code: '+247', label: 'Ascension (+247)', phoneLength: 7 },
    { code: '+248', label: 'Seychelles (+248)', phoneLength: 7 },
    { code: '+249', label: 'Sudan (+249)', phoneLength: 9 },
    { code: '+250', label: 'Rwanda (+250)', phoneLength: 9 },
    { code: '+251', label: 'Ethiopia (+251)', phoneLength: 9 },
    { code: '+252', label: 'Somalia (+252)', phoneLength: 8 },
    { code: '+253', label: 'Djibouti (+253)', phoneLength: 8 },
    { code: '+254', label: 'Kenya (+254)', phoneLength: 9 },
    { code: '+255', label: 'Tanzania (+255)', phoneLength: 9 },
    { code: '+256', label: 'Uganda (+256)', phoneLength: 9 },
    { code: '+257', label: 'Burundi (+257)', phoneLength: 8 },
    { code: '+258', label: 'Mozambique (+258)', phoneLength: 9 },
    { code: '+260', label: 'Zambia (+260)', phoneLength: 9 },
    { code: '+261', label: 'Madagascar (+261)', phoneLength: 9 },
    { code: '+262', label: 'Réunion (+262)', phoneLength: 9 },
    { code: '+263', label: 'Zimbabwe (+263)', phoneLength: 9 },
    { code: '+264', label: 'Namibia (+264)', phoneLength: 9 },
    { code: '+265', label: 'Malawi (+265)', phoneLength: 9 },
    { code: '+266', label: 'Lesotho (+266)', phoneLength: 8 },
    { code: '+267', label: 'Botswana (+267)', phoneLength: 8 },
    { code: '+268', label: 'Eswatini (+268)', phoneLength: 8 },
    { code: '+269', label: 'Comoros (+269)', phoneLength: 7 },
    { code: '+290', label: 'Saint Helena (+290)', phoneLength: 4 },
    { code: '+291', label: 'Eritrea (+291)', phoneLength: 7 },
    { code: '+297', label: 'Aruba (+297)', phoneLength: 7 },
    { code: '+298', label: 'Faroe Islands (+298)', phoneLength: 6 },
    { code: '+299', label: 'Greenland (+299)', phoneLength: 6 },
    { code: '+350', label: 'Gibraltar (+350)', phoneLength: 8 },
    { code: '+351', label: 'Portugal (+351)', phoneLength: 9 },
    { code: '+352', label: 'Luxembourg (+352)', phoneLength: 9 },
    { code: '+353', label: 'Ireland (+353)', phoneLength: 9 },
    { code: '+354', label: 'Iceland (+354)', phoneLength: 7 },
    { code: '+355', label: 'Albania (+355)', phoneLength: 9 },
    { code: '+356', label: 'Malta (+356)', phoneLength: 8 },
    { code: '+357', label: 'Cyprus (+357)', phoneLength: 8 },
    { code: '+358', label: 'Finland (+358)', phoneLength: 9 },
    { code: '+359', label: 'Bulgaria (+359)', phoneLength: 9 },
    { code: '+370', label: 'Lithuania (+370)', phoneLength: 8 },
    { code: '+371', label: 'Latvia (+371)', phoneLength: 8 },
    { code: '+372', label: 'Estonia (+372)', phoneLength: 8 },
    { code: '+373', label: 'Moldova (+373)', phoneLength: 8 },
    { code: '+374', label: 'Armenia (+374)', phoneLength: 8 },
    { code: '+375', label: 'Belarus (+375)', phoneLength: 9 },
    { code: '+376', label: 'Andorra (+376)', phoneLength: 6 },
    { code: '+377', label: 'Monaco (+377)', phoneLength: 8 },
    { code: '+378', label: 'San Marino (+378)', phoneLength: 10 },
    { code: '+379', label: 'Vatican (+379)', phoneLength: 10 },
    { code: '+380', label: 'Ukraine (+380)', phoneLength: 9 },
    { code: '+381', label: 'Serbia (+381)', phoneLength: 9 },
    { code: '+382', label: 'Montenegro (+382)', phoneLength: 8 },
    { code: '+383', label: 'Kosovo (+383)', phoneLength: 8 },
    { code: '+385', label: 'Croatia (+385)', phoneLength: 9 },
    { code: '+386', label: 'Slovenia (+386)', phoneLength: 8 },
    { code: '+387', label: 'Bosnia and Herzegovina (+387)', phoneLength: 8 },
    { code: '+389', label: 'North Macedonia (+389)', phoneLength: 8 },
    { code: '+420', label: 'Czech Republic (+420)', phoneLength: 9 },
    { code: '+421', label: 'Slovakia (+421)', phoneLength: 9 },
    { code: '+423', label: 'Liechtenstein (+423)', phoneLength: 7 },
    { code: '+500', label: 'Falkland Islands (+500)', phoneLength: 5 },
    { code: '+501', label: 'Belize (+501)', phoneLength: 7 },
    { code: '+502', label: 'Guatemala (+502)', phoneLength: 8 },
    { code: '+503', label: 'El Salvador (+503)', phoneLength: 8 },
    { code: '+504', label: 'Honduras (+504)', phoneLength: 8 },
    { code: '+505', label: 'Nicaragua (+505)', phoneLength: 8 },
    { code: '+506', label: 'Costa Rica (+506)', phoneLength: 8 },
    { code: '+507', label: 'Panama (+507)', phoneLength: 8 },
    { code: '+508', label: 'Saint Pierre and Miquelon (+508)', phoneLength: 6 },
    { code: '+509', label: 'Haiti (+509)', phoneLength: 8 },
    { code: '+590', label: 'Guadeloupe (+590)', phoneLength: 9 },
    { code: '+591', label: 'Bolivia (+591)', phoneLength: 8 },
    { code: '+592', label: 'Guyana (+592)', phoneLength: 7 },
    { code: '+593', label: 'Ecuador (+593)', phoneLength: 9 },
    { code: '+594', label: 'French Guiana (+594)', phoneLength: 9 },
    { code: '+595', label: 'Paraguay (+595)', phoneLength: 9 },
    { code: '+596', label: 'Martinique (+596)', phoneLength: 9 },
    { code: '+597', label: 'Suriname (+597)', phoneLength: 7 },
    { code: '+598', label: 'Uruguay (+598)', phoneLength: 8 },
    { code: '+599', label: 'Curaçao (+599)', phoneLength: 7 },
    { code: '+670', label: 'East Timor (+670)', phoneLength: 8 },
    { code: '+672', label: 'Norfolk Island (+672)', phoneLength: 6 },
    { code: '+673', label: 'Brunei (+673)', phoneLength: 7 },
    { code: '+674', label: 'Nauru (+674)', phoneLength: 7 },
    { code: '+675', label: 'Papua New Guinea (+675)', phoneLength: 7 },
    { code: '+676', label: 'Tonga (+676)', phoneLength: 7 },
    { code: '+677', label: 'Solomon Islands (+677)', phoneLength: 7 },
    { code: '+678', label: 'Vanuatu (+678)', phoneLength: 7 },
    { code: '+679', label: 'Fiji (+679)', phoneLength: 7 },
    { code: '+680', label: 'Palau (+680)', phoneLength: 7 },
    { code: '+681', label: 'Wallis and Futuna (+681)', phoneLength: 6 },
    { code: '+682', label: 'Cook Islands (+682)', phoneLength: 5 },
    { code: '+683', label: 'Niue (+683)', phoneLength: 4 },
    { code: '+685', label: 'Samoa (+685)', phoneLength: 7 },
    { code: '+686', label: 'Kiribati (+686)', phoneLength: 8 },
    { code: '+687', label: 'New Caledonia (+687)', phoneLength: 6 },
    { code: '+688', label: 'Tuvalu (+688)', phoneLength: 5 },
    { code: '+689', label: 'French Polynesia (+689)', phoneLength: 8 },
    { code: '+690', label: 'Tokelau (+690)', phoneLength: 4 },
    { code: '+691', label: 'Micronesia (+691)', phoneLength: 7 },
    { code: '+692', label: 'Marshall Islands (+692)', phoneLength: 7 },
    { code: '+850', label: 'North Korea (+850)', phoneLength: 9 },
    { code: '+852', label: 'Hong Kong (+852)', phoneLength: 8 },
    { code: '+853', label: 'Macau (+853)', phoneLength: 8 },
    { code: '+855', label: 'Cambodia (+855)', phoneLength: 9 },
    { code: '+856', label: 'Laos (+856)', phoneLength: 9 },
    { code: '+880', label: 'Bangladesh (+880)', phoneLength: 10 },
    { code: '+886', label: 'Taiwan (+886)', phoneLength: 9 },
    { code: '+960', label: 'Maldives (+960)', phoneLength: 7 },
    { code: '+961', label: 'Lebanon (+961)', phoneLength: 8 },
    { code: '+962', label: 'Jordan (+962)', phoneLength: 9 },
    { code: '+963', label: 'Syria (+963)', phoneLength: 9 },
    { code: '+964', label: 'Iraq (+964)', phoneLength: 10 },
    { code: '+965', label: 'Kuwait (+965)', phoneLength: 8 },
    { code: '+966', label: 'Saudi Arabia (+966)', phoneLength: 9 },
    { code: '+967', label: 'Yemen (+967)', phoneLength: 9 },
    { code: '+968', label: 'Oman (+968)', phoneLength: 8 },
    { code: '+970', label: 'Palestine (+970)', phoneLength: 9 },
    { code: '+971', label: 'United Arab Emirates (+971)', phoneLength: 9 },
    { code: '+972', label: 'Israel (+972)', phoneLength: 9 },
    { code: '+973', label: 'Bahrain (+973)', phoneLength: 8 },
    { code: '+974', label: 'Qatar (+974)', phoneLength: 8 },
    { code: '+975', label: 'Bhutan (+975)', phoneLength: 8 },
    { code: '+976', label: 'Mongolia (+976)', phoneLength: 8 },
    { code: '+977', label: 'Nepal (+977)', phoneLength: 10 },
    { code: '+992', label: 'Tajikistan (+992)', phoneLength: 9 },
    { code: '+993', label: 'Turkmenistan (+993)', phoneLength: 8 },
    { code: '+994', label: 'Azerbaijan (+994)', phoneLength: 9 },
    { code: '+995', label: 'Georgia (+995)', phoneLength: 9 },
    { code: '+996', label: 'Kyrgyzstan (+996)', phoneLength: 9 },
    { code: '+998', label: 'Uzbekistan (+998)', phoneLength: 9 },
];